import React from 'react';
import { 
  Scale, 
  Home, 
  Users, 
  Calculator, 
  FileText, 
  Briefcase,
  CreditCard,
  Trophy,
  Heart,
  Shield,
  FileCheck,
  Edit,
  Building,
  CheckSquare,
  Copyright,
  GraduationCap,
  Star,
  DollarSign
} from 'lucide-react';
import NavbarSimple from '../components/layout/NavbarSimple';
import FooterEnhanced from '../components/layout/FooterEnhanced';
import CTAButton from '../components/CTAButton';

const ServicesPage = () => {
  // Function to determine text color based on background
  const getTextColor = (bgColor) => {
    // If background is gold, use black text. Otherwise use white text.
    return bgColor.includes('gold') ? 'text-black' : 'text-white';
  };

  const services = [
    {
      id: 1,
      name: "القضايا الجزائية",
      description: "الدفاع عن الأفراد في القضايا الجزائية أمام الجهات القضائية المختصة، وتشمل قضايا القذف، التهديد، النصب والاحتيال، خيانة الأمانة، السرقة، المخدرات وغيرها، وفق إجراءات نظامية دقيقة تضمن أعلى درجات الحماية القانونية.",
      icon: Scale,
      color: "from-wazin-navy to-wazin-navy-600"
    },
    {
      id: 2,
      name: "القضايا العقارية",
      description: "تمثيل الأطراف في المنازعات العقارية بما يشمل دعاوى التملك، الإخلاء، التعويض، ونزاعات الملكية، مع متابعة جميع مراحل القضية حتى الفصل النهائي فيها.",
      icon: Home,
      color: "from-wazin-gold to-wazin-gold-600"
    },
    {
      id: 3,
      name: "القضايا الأسرية (الأحوال الشخصية)",
      description: "تقديم الدعم القانوني والترافع في قضايا الأحوال الشخصية بما يشمل الزواج، الطلاق، الحضانة، النفقة، الزيارة، مع الالتزام الكامل بالخصوصية والسرية.",
      icon: Users,
      color: "from-wazin-navy-400 to-wazin-navy-600"
    },
    {
      id: 4,
      name: "القضايا الضريبية",
      description: "الاستشارات القانونية والتمثيل أمام لجان الزكاة والضريبة فيما يخص الاعتراضات والطعون، وصياغة المذكرات النظامية بما يحفظ حقوق العميل.",
      icon: Calculator,
      color: "from-wazin-gold-400 to-wazin-gold-600"
    },
    {
      id: 5,
      name: "القضايا الإدارية",
      description: "الترافع في القضايا الإدارية أمام الجهات المختصة، وصياغة الاعتراضات والتظلمات الإدارية والطعون القضائية المرتبطة بها.",
      icon: FileText,
      color: "from-wazin-navy-500 to-wazin-navy-700"
    },
    {
      id: 6,
      name: "القضايا التجارية",
      description: "تمثيل قانوني كامل في النزاعات التجارية، يتضمن الترافع، صياغة اللوائح، ومراجعة العقود التجارية بما يتوافق مع الأنظمة السعودية.",
      icon: Briefcase,
      color: "from-wazin-gold-500 to-wazin-gold-700"
    },
    {
      id: 7,
      name: "المنازعات المصرفية والتمويلية",
      description: "تمثيل العملاء في النزاعات المتعلقة بالقروض، التمويل العقاري، والمنتجات البنكية أمام الجهات المختصة.",
      icon: CreditCard,
      color: "from-wazin-navy-600 to-wazin-navy-800"
    },
    {
      id: 8,
      name: "القضايا الرياضية",
      description: "تقديم الاستشارات والتمثيل القانوني في القضايا الرياضية للأندية واللاعبين والوسطاء أمام الجهات المحلية والدولية المختصة.",
      icon: Trophy,
      color: "from-wazin-gold to-wazin-gold-600"
    },
    {
      id: 9,
      name: "المسؤولية الطبية",
      description: "التمثيل القانوني في قضايا الأخطاء الطبية والمطالبات بالتعويض سواء للمرضى أو الممارسين الصحيين.",
      icon: Heart,
      color: "from-wazin-navy to-wazin-navy-700"
    },
    {
      id: 10,
      name: "جرائم المعلوماتية والتقنية",
      description: "الدفاع في القضايا المتعلقة بالابتزاز الإلكتروني، اختراق الحسابات، التشهير، وانتحال الهوية الرقمية.",
      icon: Shield,
      color: "from-wazin-gold-600 to-wazin-gold-800"
    },
    {
      id: 11,
      name: "التوثيق القانوني",
      description: "إعداد ومراجعة وتوثيق الوكالات، الصكوك، التنازلات، والعقود العدلية والشرعية والعقارية.",
      icon: FileCheck,
      color: "from-wazin-navy-400 to-wazin-navy-700"
    },
    {
      id: 12,
      name: "صياغة العقود والاتفاقيات",
      description: "صياغة ومراجعة العقود للأفراد والشركات مع ضمان الامتثال للنظام السعودي.",
      icon: Edit,
      color: "from-wazin-gold to-wazin-gold-700"
    },
    {
      id: 13,
      name: "تأسيس وتعديل الشركات / الجهات غير الربحية",
      description: "إجراءات تأسيس الشركات والجهات غير الربحية وتعديل أنظمتها ومراجعة عقود التأسيس.",
      icon: Building,
      color: "from-wazin-navy-500 to-wazin-navy-800"
    },
    {
      id: 14,
      name: "الامتثال والحوكمة القانونية",
      description: "إعداد السياسات واللوائح ومراجعة التزام المنشآت بالأنظمة ذات العلاقة.",
      icon: CheckSquare,
      color: "from-wazin-gold-500 to-wazin-gold-800"
    },
    {
      id: 15,
      name: "الملكية الفكرية",
      description: "تسجيل العلامات التجارية وحقوق الملكية الفكرية وتمثيل العملاء في النزاعات المتعلقة بها.",
      icon: Copyright,
      color: "from-wazin-navy-600 to-wazin-gold-600"
    },
    {
      id: 16,
      name: "التدريب والتأهيل القانوني",
      description: "برامج تدريبية وتأهيل للمحامين وطلاب القانون تشمل التطبيق العملي وصياغة المذكرات.",
      icon: GraduationCap,
      color: "from-wazin-gold-400 to-wazin-gold-700"
    },
    {
      id: 17,
      name: "الباقة السنوية القانونية",
      description: "خدمات قانونية مستمرة للشركات والأفراد عبر اشتراك سنوي شامل.",
      icon: Star,
      color: "from-wazin-gold to-wazin-gold-800"
    },
    {
      id: 18,
      name: "التحصيل والتسويات الودية",
      description: "تحصيل الديون، التفاوض الودي، وصياغة اتفاقيات السداد قبل اللجوء للقضاء.",
      icon: DollarSign,
      color: "from-wazin-navy to-wazin-gold"
    }
  ];

  const handleRequestService = (serviceName) => {
    // رابط واتساب وازن
    const whatsappNumber = "966122226665";
    const message = encodeURIComponent(`مرحباً، أرغب في الاستفسار عن خدمة: ${serviceName}`);
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <NavbarSimple />
      <CTAButton />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-wazin-navy via-wazin-navy-700 to-wazin-navy-dark text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">خدماتنا القانونية</h1>
          <p className="text-xl text-wazin-gold-100 max-w-3xl mx-auto">
            نقدم مجموعة شاملة من الخدمات القانونية المتخصصة للأفراد والشركات
            بأعلى معايير الاحترافية والجودة
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = service.icon;
            const textColor = getTextColor(service.color);
            const iconBgColor = service.color.includes('gold') ? 'bg-wazin-navy/20' : 'bg-white/20';
            
            return (
              <div
                key={service.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
              >
                {/* Icon Header */}
                <div className={`bg-gradient-to-r ${service.color} p-6`}>
                  <div className={`flex items-center justify-center w-16 h-16 ${iconBgColor} rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <IconComponent className={`w-8 h-8 ${textColor}`} />
                  </div>
                  <h3 className={`text-xl font-bold ${textColor}`}>{service.name}</h3>
                </div>

                {/* Description */}
                <div className="p-6">
                  <p className="text-gray-700 leading-relaxed mb-6 min-h-[120px]">
                    {service.description}
                  </p>

                  {/* CTA Button */}
                  <button
                    onClick={() => handleRequestService(service.name)}
                    className={`w-full bg-gradient-to-r ${service.color} ${textColor} py-3 px-6 rounded-xl font-bold 
                    hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 
                    flex items-center justify-center gap-2`}
                  >
                    <span>اطلب الخدمة</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Bottom CTA */}
      <div className="bg-gradient-to-r from-wazin-gold to-wazin-gold-600 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4 text-wazin-navy">هل تحتاج استشارة قانونية؟</h2>
          <p className="text-xl mb-8 text-wazin-navy-700">تواصل معنا الآن وسيقوم فريقنا بالرد عليك في أقرب وقت</p>
          <button
            onClick={() => window.open('https://wa.me/966122226665', '_blank')}
            className="bg-wazin-navy text-white px-8 py-4 rounded-xl font-bold text-lg 
            hover:bg-wazin-navy-700 transform hover:scale-105 transition-all duration-300 shadow-xl"
          >
            تواصل معنا عبر واتساب
          </button>
        </div>
      </div>

      <FooterEnhanced />
    </div>
  );
};

export default ServicesPage;
